import { CheckItemDto } from '../check-dto';
import { OOCheck } from '../oo-check';
import { OOCheckItem } from '../oo-check-item';
import { OrderPayment } from '../order';
import { OrderPaymentTypes } from '../order-payment-types.enum';

export class I4goPaymentRequestDTO {
	shipping?: I4goAddress = new I4goAddress();
	billing: I4goAddress = new I4goAddress();
	customer: I4goCustomer = new I4goCustomer();
	checkItems: OOCheckItem[] | CheckItemDto[] = [];

	public constructor(init?: Partial<I4goPaymentRequestDTO>) {
		Object.assign(this, init);
	}

	static fromOOcheck(check: OOCheck): I4goPaymentRequestDTO {
		return new I4goPaymentRequestDTO({
			billing: {
				street: check.billing.address1,
				city: check.billing.city,
				state: check.billing.state,
				zip: check.billing.postalCode,
			},
			shipping: {
				street: check.shipping.address1 || check.billing.address1,
				city: check.shipping.city || check.billing.city,
				state: check.shipping.state || check.billing.state,
				zip: check.shipping.postalCode || check.billing.postalCode,
			},
			customer: {
				firstName: check.billing.firstName,
				lastName: check.billing.lastName,
				email: check.billing.email,
				phone: check.billing.phone,
			},
			checkItems: check.items.map((i) => i),
		});
	}
}

class I4goAddress {
	street?: string;
	city?: string;
	state?: string;
	zip?: string;

	public constructor(init?: Partial<I4goAddress>) {
		Object.assign(this, init);
	}
}

class I4goCustomer {
	firstName?: string;
	lastName?: string;
	email?: string;
	phone?: string;

	public constructor(init?: Partial<I4goCustomer>) {
		Object.assign(this, init);
	}
}

export class I4goPaymentResponseDTO {
	token: string;
	displayName: string;
	streetAddress: string;
	postalCode: string;
	extendedCardData: string;
	i4goData: any;
	cardNumber: string;
	cardType: string;
	expirationMonth: string;
	expirationYear: string;
	securityCode: string;
	firstName: string;
	lastName: string;
	amount: number;
	pspReference: string;
	alias: string;
	applePayToken: string;
	googlePayToken: string;
	sendToProcessor: boolean;
	kioskPaymentRequestKey: string;

	public constructor(init?: Partial<I4goPaymentResponseDTO>) {
		Object.assign(this, init);
	}

	static toOrderPayment(payment: I4goPaymentResponseDTO, tipAmount: number): OrderPayment {
		return new OrderPayment({
			amount: payment.amount,
			tip: tipAmount,
			token: payment.token,
			securityCode: payment.securityCode,
			type: OrderPaymentTypes.CreditCard,
			firstName: payment.firstName,
			lastName: payment.lastName,
			postalCode: payment.postalCode,
			extendedCardData: payment.extendedCardData,
			tipPercent: undefined,
			displayName: payment.displayName,
			pspReference: payment.pspReference,
		});
	}
}
